module.exports = __webpack_public_path__ + "img/logo_login_banner.29b5173f.png";